import { ModalType, useModalContext } from 'modules/campaigns/editor/context';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { Stop } from 'ui/icons';
import { CampaignPopover } from '../../../CampaignPopover';
import { CampaignPermissionCheck } from '../../CampaignPermissionCheck';

export const CancelCampaignAction = () => {
  const { openModal } = useModalContext();

  return (
    <CampaignPermissionCheck action="cancel" ChildWrapper={CampaignPopover}>
      <DestructiveButton
        data-test="cancel-campaign-button"
        size={BUTTON_SIZES.LARGE}
        onClick={() => openModal(ModalType.CancelCampaignModal)}
      >
        <Stop />
        Cancel campaign
      </DestructiveButton>
    </CampaignPermissionCheck>
  );
};
